import { Notification, NotificationStatus } from '@copera/notification';
import { Avatar, Stack, Typography, styled } from '@mui/material';
import { noCase } from 'change-case';
import { useNavigate } from 'react-router';
import Iconify from 'src/components/iconify';
import { useNotificationContent } from '../useNotificationContent';
import { useUpdateNotificationMutation } from '../useUpdateNotificationMutation';

const ContentStyled = styled(Typography)(() => ({
  maxWidth: '40ch',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

export const NotificationCard = ({
  notification,
}: { notification: Notification }) => {
  const navigate = useNavigate();

  const { getNotificationContent } = useNotificationContent();
  const { icon, title, description, navigateTo } =
    getNotificationContent(notification);

  const { updateNotification } = useUpdateNotificationMutation();

  const handleClick = async () => {
    if (navigateTo) {
      navigate(navigateTo);
    }

    await updateNotification({
      id: notification._id || '',
      status: NotificationStatus.READ,
    });
  };

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      onClick={handleClick}
    >
      <Avatar sx={{ bgcolor: 'background.neutral' }}>
        <Iconify icon={icon} width={24} />
      </Avatar>

      <Typography variant="subtitle2">
        {title}
        <br />
        <ContentStyled
          as="span"
          variant="body2"
          sx={{ color: 'text.secondary' }}
        >
          {noCase(description)}
        </ContentStyled>
      </Typography>
    </Stack>
  );
};
